<!--
 * @Author       : aa
 * @Date         : 2020-06-15 12:05:17
 * @Description  : 题号列表
 * @FilePath     : \vue-gaokao-ebook\src\views\my_personal\my_evaluation\evaluated_card.vue
--> 
<template>
  <div class="question_card">
    <div class="card">
      <div class="nav">题号索引</div>
      <div class="comparison">
        <div>
          <div class="already"></div>
          <span>正确</span>
        </div>
        <div>
          <div class="not_yet"></div>
          <span>错误</span>
        </div>
        <!-- <div>
                <div class="no_pigai"></div>
                <span>未批改</span>
            </div> -->
        <div>
          <div class="no_pigai"></div>
          <span>未作答</span>
        </div>
      </div>
      <div
        class="number_list_wen"
        v-if="
          paper.subjectId == 9 ||
          paper.subjectId == 11 ||
          paper.subjectId == 16 ||
          paper.subjectId == 15 ||
          paper.subjectId == 17
        "
      >
        <div
          v-for="(qs, index) in questionStatus"
          :key="index"
          :sss="qs.originalName"
          :class="[
            activeClass(qs.correct, qs.status),
            { active: index == activeIndex },
          ]"
          :id="'anchor' + qs.id"
          @click="gotoTarget(index)"
          v-html="`${qs.originalName}`"
        ></div>
      </div>
      <div class="number_list" v-else>
        <el-tabs
          tab-position="left"
          style="height: 100%"
          v-model="tabPosition"
          @tab-click="tabelChange"
        >
          <el-tab-pane
            v-for="(qs, key) in newQuestionStatus"
            :label="key"
            :name="key"
            :key="key"
          >
            <div
              :sss="cqs.status"
              v-for="(cqs, index) in newQuestionStatus[key]"
              :key="index"
              :class="[
                activeClass(cqs.correct, cqs.status),
                { active: cqs.index == activeIndex },
              ]"
              :id="'anchor' + cqs.id"
              @click="gotoTarget(cqs.index)"
            >
              {{ cqs.name }}
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="btns">
      <el-button
        :class="index == 0 ? 'btn-dis' : 'btn'"
        :disabled="index == 0"
        @click="gotoTarget(index - 1)"
        >上一题</el-button
      >
      <el-button
        :class="index == questionStatus.length - 1 ? 'btn-dis' : 'btn'"
        :disabled="index == questionStatus.length - 1"
        @click="gotoTarget(index + 1)"
        >下一题</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabPosition: "0",
      activeIndex: 0,
      question_tab: 1,
      index: 0
    };
  },
  props: {
    paper: Object,
    newQuestionStatus: Object,
    questionStatus: Array,
    questionSubmitInfo: Object,
    answerCount: Number
  },
  computed: {
    activeClass() {
      return (correct, completionStatus) => {
        if (completionStatus) {
          if (correct) {
            return "already";
          } else {
            return "not_yet";
          }
        } else {
          return "no_pigai";
        }
      };
    }
  },
  components: {},

  methods: {
    tabelChange(val) {
      let index = this.newQuestionStatus[val.label][0].index;
      this.gotoTarget(index);
    },
    gotoTarget(indexChanged) {
      this.index = indexChanged;
      let qs = this.questionStatus[indexChanged];
      this.activeIndex = indexChanged;
      this.question_tab = qs.order;
      console.log(qs.order, qs.id, "000");
      this.$root.eventHub.$emit("question-tab-changed", qs.order, qs.id);

      if (
        this.paper.subjectId == 10 ||
        this.paper.subjectId == 12 ||
        this.paper.subjectId == 13 ||
        this.paper.subjectId == 14
      ) {
        for (const key in this.newQuestionStatus) {
          for (
            let index = 0;
            index < this.newQuestionStatus[key].length;
            index++
          ) {
            const element = this.newQuestionStatus[key][index];
            if (element.index == indexChanged) {
              this.tabPosition = key;
              return false;
            }
          }
        }
      }
    }
  },
  mounted() {
    console.log(this.newQuestionStatus, "newQuestionStatus");
    this.$nextTick(() => {
      this.tabPosition = "0";
      this.$root.eventHub.$on("question-tab-changed1", order => {
        let array = this.questionStatus;
        for (let index = 0; index < array.length; index++) {
          let element = array[index];
          if (element.order == order) {
            this.activeIndex = index;
            this.question_tab = element.order;
            // this.id = element.id;
          }
        }
      });
      this.gotoTarget(0);
      console.log(
        this.newQuestionStatus,
        "newQuestionStatus",
        this.paper,
        this.questionStatus
      );
    });
  }
};
</script>
<style lang="scss" scoped>
.question_card {
  width: 400px;
  position: fixed;
  height: 99%;
  z-index: 1000;
  background-color: #f5f5f5;
  margin-left: 12px;
  .card {
    width: 298px;
    overflow: hidden;
    height: 500px;
    border: 1px #5c307d solid;
    margin-top: 30px;
    margin-left: 20px;
    background-color: #ffffff;
    .nav {
      width: 300px;
      height: 38px;
      background-color: #5c307d;
      color: #ffffff;
      text-align: center;
      line-height: 38px;
    }
    .comparison {
      width: 300px;
      height: 45px;
      margin-top: 25px;
      display: flex;
      justify-content: space-around;
      .already {
        width: 20px;
        height: 20px;
        background-color: #a7f1c0;
        border: 1px #2fb700 solid;
        margin-top: 3px;
        float: left;
      }

      .not_yet {
        width: 20px;
        height: 20px;
        background-color: #ffbfbf;
        border: 1px #ff8181 solid;
        float: left;
        margin-top: 3px;
      }

      .no_pigai {
        width: 20px;
        height: 20px;
        background-color: #ffffff;
        border: 1px #5c307d solid;
        float: left;
        margin-top: 3px;
      }

      span {
        font-size: 19px;
        color: #5c307d;
        margin-left: 10px;
      }
    }

    .number_list {
      width: 300px;
      height: 390px;
      overflow-x: hidden;
      .active {
        border: 1px solid #5c307d;
        background-color: #f1dfff;
      }
      .already {
        width: 55px;
        height: 38px;
        border: 1px #2fb700 solid;
        float: left;
        margin-left: 15px;
        margin-top: 15px;
        text-align: center;
        line-height: 38px;
        font-size: 17px;
        background-color: #a7f1c0;
        cursor: pointer;
      }

      .not_yet {
        width: 55px;
        height: 38px;
        border: 1px #ff8181 solid;
        float: left;
        margin-left: 15px;
        margin-top: 15px;
        text-align: center;
        line-height: 38px;
        font-size: 16px;
        background-color: #ffbfbf;
        cursor: pointer;
      }

      .no_pigai {
        width: 38px;
        height: 38px;
        border: 1px #5c307d solid;
        float: left;
        margin-left: 15px;
        margin-top: 15px;
        text-align: center;
        line-height: 38px;
        font-size: 16px;
        background-color: #ffffff;
        cursor: pointer;
      }
    }
    .number_list_wen {
      width: 300px;
      max-height: 380px;
      overflow-x: hidden;
      display: -webkit-flex;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 24px;
      padding-bottom: 5px;
      .already {
        width: 68px;
        height: 38px;
        border: 1px #d5d5d5 solid;
        margin-top: 15px;
        text-align: center;
        line-height: 38px;
        font-size: 17px;
        background-color: #a7f1c0;
        cursor: pointer;
      }

      .not_yet {
        width: 68px;
        height: 38px;
        border: 1px #5c307d solid;
        margin-top: 15px;
        text-align: center;
        line-height: 38px;
        font-size: 16px;
        background-color: #ffbfbf;
        cursor: pointer;
      }

      .choose {
        width: 68px;
        height: 38px;
        border: 1px #5c307d solid;
        margin-top: 15px;
        text-align: center;
        line-height: 38px;
        font-size: 16px;
        background-color: #f1dfff;
        cursor: pointer;
      }

      .no_pigai {
        width: 68px;
        height: 38px;
        border: 1px #5c307d solid;
        margin-top: 15px;
        text-align: center;
        line-height: 38px;
        font-size: 16px;
        background-color: #fff;
        cursor: pointer;
      }
      .active {
        border: 1px solid #5c307d;
        background-color: #f1dfff;
      }
    }
    .number_list_wen:after {
      content: "";
      width: 68px;
    }
  }

  .btns {
    width: 330px;
    height: 130px;
    position: relative;
    float: left;
    .btn-dis {
      width: 110px;
      height: 50px;
      margin-left: 35px;
      margin-top: 30px;
      background-color: #aaaaaa;
      color: #ffffff;
      font-size: 24px;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
      float: inherit;
      line-height: 1;
    }
    .btn {
      width: 110px;
      height: 50px;
      margin-left: 35px;
      margin-top: 30px;
      background-color: #5c307d;
      color: #ffffff;
      font-size: 24px;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
      float: inherit;
      line-height: 1;
    }
    .btn:hover {
      background-color: #ff3a00;
    }
  }
}
</style>
